import { IBoxWidgetData, IWidgetContainer, IWidgetData } from "@pageBuilder/typings";
import { CascadeRendererBase } from "src/shared/cascade-renderer-base";
import { RendererFactory } from "src/shared/renderer-factory";
import { ElementUtil } from "src/utils/element-util";
import { BoxWidgetRenderer } from "../renderers/box-widget/box-widget-renderer";
import { IRenderingCommonContext } from "@commonRendering/types";

export class BoxWidgetCascadeRenderer extends CascadeRendererBase<IBoxWidgetData> {

    protected readonly renderer: BoxWidgetRenderer;

    public constructor(renderingCommonContext: IRenderingCommonContext) {
        super(renderingCommonContext);
        this.renderer = new BoxWidgetRenderer(renderingCommonContext);
    }

    public override createByCascade(data: IBoxWidgetData): HTMLElement {
        const boxWidgetElement = this.createWidgetByCascade(data);
        data.childWidgets = data.childWidgets ?? [];
        data.hoverChildWidgets = data.hoverChildWidgets ?? [];

        const regularWidgetsArea = boxWidgetElement.querySelector<HTMLElement>(".widget-content.regular > [data-widgets-area]");
        const hoverWidgetsArea = boxWidgetElement.querySelector<HTMLElement>(".widget-content.hover > [data-widgets-area]");

        data.childWidgets?.forEach(childWidgetData => {
            const childWidgetElement = this.createWidgetByCascade(childWidgetData);
            regularWidgetsArea?.append(childWidgetElement);
        });

        data.hoverChildWidgets?.forEach(hoverChildWidgetData => {
            const childWidgetElement = this.createWidgetByCascade(hoverChildWidgetData);
            hoverWidgetsArea?.append(childWidgetElement);
        });

        return boxWidgetElement;
    }

    private createWidgetByCascade(widgetData: IWidgetData): HTMLElement {
        const widgetRenderer = RendererFactory.create(widgetData.type, this.renderingCommonContext);
        const widgetElement = widgetRenderer.createNew();
        widgetRenderer.render(widgetElement, widgetData);

        return widgetElement;
    }

    public override getDataByCascade(element: HTMLElement): IBoxWidgetData {
        const type = ElementUtil.resolveElementType(element);
        const widgetRenderer = RendererFactory.create(type, this.renderingCommonContext);

        const widgetData = widgetRenderer.getData(element) as IBoxWidgetData;
        const widgetContainerData = widgetData as IWidgetContainer;

        widgetContainerData.childWidgets = [];
        widgetContainerData.hoverChildWidgets = [];

        const regularWidgets = element.querySelectorAll<HTMLElement>(".widget-content.regular > [data-widgets-area] [data-widget]");
        const hoverWidgets = element.querySelectorAll<HTMLElement>(".widget-content.hover > [data-widgets-area] [data-widget]");

        regularWidgets.forEach((childWidgetElement: HTMLElement) => {
            const childWidgetType = ElementUtil.resolveElementType(childWidgetElement);
            const childWidgetRenderer = RendererFactory.create(childWidgetType, this.renderingCommonContext);
            const childWidgetData = childWidgetRenderer.getData(childWidgetElement) as IWidgetData;
            widgetContainerData.childWidgets?.push(childWidgetData);
        });

        hoverWidgets.forEach((childWidgetElement: HTMLElement) => {
            const childWidgetType = ElementUtil.resolveElementType(childWidgetElement);
            const childWidgetRenderer = RendererFactory.create(childWidgetType, this.renderingCommonContext);
            const childWidgetData = childWidgetRenderer.getData(childWidgetElement) as IWidgetData;
            widgetContainerData.hoverChildWidgets?.push(childWidgetData);
        });

        return widgetData;
    }

}
